// const debug = "ScheduleManger"
const debug = false

export default class ScheduleManger {

    // DEPRECATE ?
    // SEE taskAutoUpdateScheduleDate ???

    static calculateScheduleDate(companyId:ID, startDate:any, endDate:any, scheduleDate:any, isNewTask?:boolean){
        debug && console.log(debug, 'calculateScheduleDate', startDate, endDate, scheduleDate, isNewTask)

        //convert to Moment
        let newStartDate        = typeof startDate === 'string' ? moment(startDate) : startDate;
        let newEndDate          = typeof endDate === 'string' ? moment(endDate) : endDate;
        let newScheduleDate     = typeof scheduleDate === 'string' ? moment(scheduleDate) : scheduleDate;

        //normalize start/end dates
        if (!newStartDate && newEndDate) newStartDate = newEndDate;
        if (!newEndDate || (newEndDate && newEndDate.isBefore(newStartDate)))
            newEndDate = newStartDate;

        //check if auto schedule enabled
        const { autoScheduleNewTasks, autoScheduleUpdatedTasks } = gd.company.settings.labs.planning;
        const calculateScheduleDate = isNewTask ? autoScheduleNewTasks : autoScheduleUpdatedTasks;

        if (calculateScheduleDate) {
            //see if we need to adjust schedule date
            if (!newScheduleDate || newScheduleDate.isBefore(newStartDate, 'day') || newScheduleDate.isAfter(newEndDate, 'day')) {
                //if start date is before today -> today else startDate
                if (newStartDate && newStartDate.isBefore(moment())) newScheduleDate = moment(); // today
                else                                                 newScheduleDate = newStartDate;
            }
        }

        debug && console.log(debug, 'calculateScheduleDate res', {
            startDate       : newStartDate,
            endDate         : newEndDate,
            scheduleDate    : newScheduleDate
        })

        return {
            startDate       : newStartDate,
            endDate         : newEndDate,
            scheduleDate    : newScheduleDate
        };
    }
}
